import { useState } from "react";

import AgentPoliciesBody from "./AgentPoliciesBody";
import AgentPoliciesSidebar from "./AgentPoliciesSidebar";

const AgentPolicyContent = ({ selectedHost }) => {
  const [selectedPolicy, setSelectedPolicy] = useState(null);

  const selectPolicyHandler = (_, policy) => {
    setSelectedPolicy(policy);
  };

  return (
    <div className="agent-policy-content">
      <AgentPoliciesSidebar
        onPolicySelect={selectPolicyHandler}
        selectedPolicy={selectedPolicy}
        selectedHost={selectedHost}
      />
      <AgentPoliciesBody selectedPolicy={selectedPolicy} selectedHost={selectedHost} />
    </div>
  );
};

export default AgentPolicyContent;
